export default __webpack_public_path__ + "static/SiemensSans-Roman-5186a017ece1ce1490f07cf6944ea3a0.woff2";